import { render, staticRenderFns } from "./myNeeds.vue?vue&type=template&id=7c62a0eb&scoped=true&"
import script from "./myNeeds.vue?vue&type=script&lang=js&"
export * from "./myNeeds.vue?vue&type=script&lang=js&"
import style0 from "./myNeeds.vue?vue&type=style&index=0&id=7c62a0eb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c62a0eb",
  null
  
)

export default component.exports